import DeleteModalBridge from '@Client/runner.shared/modal/bridge/DeleteModalBridge';
import angular from 'angular';

angular
  .module('flowingly.runner.flow')
  .component('deleteModal', DeleteModalBridge);
